module.exports = __webpack_public_path__ + "static/media/purityx-logo.6e89a93c.png";